<template>
  <div class="about">

    <section id="portada" class="animacion">
        <div class="contedor-portada">
          <div class="portada-contenido animacion">
          <h1>{{nom_sub_sec_es}}</h1>
          <ul>
            <li><router-link tag="a" to="/">Inicio</router-link></li>
            <li class="sin-division">{{nom_sub_sec_es}}</li>
          </ul>
          </div>
          <img
            class="imagen-cover"
            v-bind:src='imgPreUrl+ url_1st_image +"x640.jpg"'
            v-bind:alt='type_1st_image'>
        </div>
    </section>

      <section id="noticias" class="secciones seccion-blanca text-center">
      <div class="container">
          

  <template v-if="detail_open">
      <!-- Contenido de la Página -->
    <section id="contenido-general" class="secciones seccion-blanca">
      <div class="container">
        <br>
        <br>
        <div class="col-12 sin-padding">
          <button @click="closeSignedDetail()" class="btn btn-info btn-3d btn-3d-sm btn-3d-celeste ico-atras"><i class="fa fa-arrow-left"></i>{{ " Atrás" }}</button>
         <!-- <div class="botones-compartir">
            <span>{{ "Compartir " }}:</span>
            <a href="javascript: void(0);"  :onclick="boton_fb" data-toggle="tooltip" data-placement="top" title="Compartir en Facebook" class="btn-compartir btn-fb"><i class="fa fa-facebook"></i></a>
            <a v-bind:href="boton_tw" onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');return false;" data-toggle="tooltip" data-placement="top" title="Compartir en Twitter" class="btn-compartir btn-tt"><i class="fa fa-twitter"></i></a>
         </div> -->
        </div>
        <div class="col-12 sin-padding">
          <div class="noticia-fecha"><strong>{{ detail_item.date_new | esDate }}</strong></div>
          <div class="noticia-titulo">
            <h1>{{ detail_item.title_news_es }}</h1>
          </div>
          <div class="noticia-galeria">
            <!--  Galería de fotos  -->
            <template v-if='detail_item.url_2nd_image=="products/empty-img" && detail_item.url_3rd_image=="products/empty-img" && detail_item.url_4th_image=="products/empty-img"'>
                <div class="carrusel-noticia" style="">
               
                    <img v-bind:src='imgPreUrl+ detail_item.url_main_image +"x640.jpg"' alt="" class="imagen-cover">
                  
                </div> 
            </template>
            <template v-else>
              <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators">
                  <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                  <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                  <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                </ol>
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <img class="imagen-cover" v-bind:src='imgPreUrl+ detail_item.url_main_image +"x640.jpg"' alt="First slide">
                  </div>
                  <template v-if='detail_item.url_2nd_image!="" && detail_item.url_2nd_image!="products/empty-img"'>
                    <div class="carousel-item">
                      <img class="noticia-galeria" v-bind:src='imgPreUrl+ detail_item.url_2nd_image +"x640.jpg"' alt="Second slide">
                    </div>
                  </template>
                  <template v-if='detail_item.url_3rd_image!="" && detail_item.url_3rd_image!="products/empty-img"'>
                    <div class="carousel-item">
                      <img class="noticia-galeria" v-bind:src='imgPreUrl+ detail_item.url_3rd_image +"x640.jpg"' alt="Third slide">
                    </div>
                  </template>
                  <template v-if='detail_item.url_4th_image!="" && detail_item.url_4th_image!="products/empty-img"'>
                    <div class="carousel-item">
                      <img class="noticia-galeria" v-bind:src='imgPreUrl+ detail_item.url_4th_image +"x640.jpg"' alt="Four slide">
                    </div>
                  </template>
                </div>
                <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">Next</span>
                </a>
              </div>
            </template>
            
          </div>
          <div class="noticia-cuerpo">
            <p><span v-html=" detail_item.desc_news_es "></span></p>
          </div>
        </div>
        <div class="col-12 sin-padding">
          <button @click="closeSignedDetail()" class="btn btn-info btn-3d btn-3d-sm btn-3d-celeste ico-atras"><i class="fa fa-arrow-left"></i>{{ " Atrás" }}</button>
           <!-- <div class="botones-compartir">
            <span>{{ "Compartir " }}:</span>
            <a href="javascript: void(0);"  :onclick="boton_fb" data-toggle="tooltip" data-placement="top" title="Compartir en Facebook" class="btn-compartir btn-fb"><i class="fa fa-facebook"></i></a>
            <a v-bind:href="boton_tw" onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');return false;" data-toggle="tooltip" data-placement="top" title="Compartir en Twitter" class="btn-compartir btn-tt"><i class="fa fa-twitter"></i></a>
         </div> -->
        </div>
      </div>
    </section>
  </template>
  <template v-else>

    <template v-if='item_list.length!=0 || main_item!=""'>

       <h1>{{internal_name_es}}</h1>
      <span v-html="desc_sub_section_es"></span>  

      <!-- Contenido de la Página -->
      <section id="noticias" class="secciones seccion-blanca text-center" style="padding-top: 0px;">
        <div class="container">				

         
            <form @submit="buscar_noticias()" class="input-group mb-3">
              <input type="text" class="form-control" v-model="search_atributte" placeholder="Ingrese nombre, contenido o etiqueta de la entrada que desea buscar" aria-label="Recipient's username" aria-describedby="basic-addon2">
              <div class="input-group-append">
                <button class="btn btn-outline-primary" type="button" style="font-size: 12px;" @click="buscar_noticias()">Buscar</button>
              </div>
            </form>

            <div :class="[(mensaje_error === '') ? 'd-none' : 'alert alert-danger']" role="alert"><strong>{{ mensaje_error }}</strong></div>
          
          
        </div>
          
        <div v-if="!search" class="container noticias-principal">
          
              <div class="noticias ancho-total">
                <a @click="openSignedDetail(main_item)" class="noticias-foto ancho-medio">
                  <img v-bind:src='imgPreUrl+ main_item.url_main_image +"x640.jpg"' v-bind:alt='main_item.title_news_es' class="imagen-cover">
                </a>
                <a @click="openSignedDetail(main_item)" class="noticias-contenido ancho-medio">
                  <span style="color: white;background-color: grey;margin-bottom: 10px;padding: 5px;font-size: 12px;"><small><strong>ENTRADA DESTACADA <i class="fa fa-star"></i></strong></small></span>
                  <br>
                  <div class="noticias-fecha">
                    <br><p><strong>{{ main_item.date_new | esDate }}</strong></p></div>
                  

                  <div class="noticias-titulo"><h2><strong>{{ main_item.title_news_es  }}</strong></h2></div>
                  <div class="noticias-texto"><p>{{ (main_item.desc_news_es).substring(0, 70)+"..."  | striphtml }}</p></div>
                </a>
                <button @click="openSignedDetail(main_item)"  class="btn-al btn-al-sm btn-al-celeste-solid noticias-boton">{{"Seguir Leyendo" }}</button>
              </div>
            
          
        </div>
        <div class="container sin-padding seccion-blanca">
          <div class="container sin-padding">
            <div class="row noticias-grupo">

              <div class="col-lg-6" v-for="(item, index) in item_list" :key="index">
                <div class="noticias">
                  <a @click="openSignedDetail(item)"  class="noticias-foto">
                  <img v-bind:src='imgPreUrl+ item.url_main_image +"x320.jpg"' v-bind:alt='item.title_news_es' class="imagen-cover">
                  </a>
                  <a @click="openSignedDetail(item)"  class="noticias-contenido">
                    <div class="noticias-fecha" ><p><strong>{{ item.date_new | esDate }}</strong></p></div>
                    

                    <div class="noticias-titulo"><h2><strong>{{ item.title_news_es  }}</strong></h2></div>
                    <div class="noticias-texto"><p>{{(item.desc_news_es).substring(0, 70)+"..." | striphtml }}</p></div>
                  </a>
                  <button @click="openSignedDetail(item)"  class="btn-al btn-al-sm btn-al-celeste-solid noticias-boton">{{ "Seguir Leyendo" }}</button>
                </div>
              </div>
              
              <div v-if="!search" class="col-12">
                <div class="paginador text-center"> 
                  <ul>
                    <template v-if="current_page > 1">
                      <li><button class="btn page-item" @click="listadoPagina(current_page - 1)"><span> <i class="fa fa-arrowleft"></i> </span></button></li>
                    </template>
                    <template v-else>
                      <li><button class="btn page-item pag-desactivado"><span> <i class="fa fa-arrow-left"></i> </span></button></li>
                    </template>
                    <li v-for="page in pages" :key="page"><button :class="['btn page-item', (page === current_page) ? 'active' : '']" @click='page == 1 ? obtener_items_paginado() : listadoPagina(page)'>{{page}}</button></li>
                    <template v-if="current_page == final_page">
                      <li><button class="btn page-item pag-desactivado"><span><i class="fa fa-arrow-right"></i></span></button></li>
                    </template>
                    <template v-else>
                      <li><button  @click="listadoPagina(current_page + 1)" class="btn page-item"><span><i class="fa fa-arrow-right"></i></span></button></li>
                    </template>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </template>
    <template v-else>
      <section id="noticias" class="noticias-internas">  
        <div class="seccion-blanca">
          <div class="container"> 
            <div class="row noticias-grupo"> 
              <div class="col-12 text-center">
                <h3>{{mensaje_prev}}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>

  </template>

      </div>
    </section>

   

    <TwoModules></TwoModules>
    <NewModules></NewModules>

   

  </div>

</template>

<style>

</style>

<script>
import TwoModules from "@/components/products/TwoModules.vue";
import NewModules from "@/components/products/NewModule.vue";
import axios from "axios";
import {config_settings} from '../config.js';
import _ from "lodash";
import { errorToaster } from '../components/shared/service/ErrorHandler';

//HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const INTERNAL_SERVER_ERROR = 500;

  axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});



export default {
 
  components: {
    TwoModules,
    NewModules
  },
  data() {
    return {
      page_title: "",
      page_description: "",
      page_keywords: "",

      url_actual: "",
      mensaje_prev : "loading...",
      detail_open: false,
      main_item : "",
      display: 'redbox',
      imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
      cod_sub_sec: 23,
      nom_sub_sec_es: '',
      nom_sub_sec_en: '',
      internal_name_es: '',
      internal_name_en: '',
      desc_sub_section_es: '',
      desc_sub_section_en: '',
      section: '',
      url_1st_image: 'utils/empty-img',
      url_2nd_image: 'utils/empty-img',
      url_3rd_image: 'utils/empty-img',
      url_4th_image: 'utils/empty-img',
      url_5th_image: 'utils/empty-img',
      type_1st_image: 'image',
      type_2nd_image: 'image',
      type_3rd_image: 'image',
      type_4th_image: 'image',
      type_5th_image: 'image',
      text1_es: '',
      text1_en: '',
      text2_es: '',
      text2_en: '',
      text3_es: '',
      text3_en: '',
      orientation: '',
      url_es: '',
      url_en: '',
      order_sub_section: '',
      id_position_menu: '',
      url_video: '',
      type: '',
      item_list: [],
      crit: 4,
      pages: [],
      final_page: 1,
      current_page: 1,
      detail_item: new Object(),
      load_complete: false,
      boton_fb: "",
      boton_tw: "",
      boton_ld: "",
      search_atributte: "",
      mensaje: "",
      mensaje_error: "",
      search: false,
      id_news_url: this.$route.params.idnews
    
    }
  },

  metaInfo() {

        return {
             title:  this.page_title ? this.page_title : "",
             meta: [
              { name: 'description', content: this.page_description ? this.page_description : "" },
              { name: 'keywords', content: this.page_keywords ? this.page_keywords : "" },
              { name: 'robots', content: "index" }
            ]
        }
  },
  
  methods: {

    buscar_noticias() {
      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL+'/POST/news/search',
        data: {
          "query": this.search_atributte
        }
      })
      .then(response => {
        console.log("Holaaaaaaa")
        this.item_list = response.data.news;
        this.mensaje = 'Resultados de la búsqueda para: ' + this.search_atributte
        this.mensaje_error = ""
        this.pages = [1]
        this.current_page = 1
        this.final_page = 1
        this.search = true
      })
      .catch(error => {
        if(error.response.status === BAD_REQUEST){
          toastr.error("Debes ingresar un parámetro de búsqueda válido",
                       "Error", 
                       {"iconClass": 'customer-danger'});
        }
        else if(error.response.status === NOT_FOUND){
          this.mensaje_error = 'No se encontraron resultados de la búsqueda para: ' + this.search_atributte
          this.mensaje = ""
        }
        else if(error.response.status === UNAUTHORIZED){
           this.refreshToken().then(_ => {
           this.buscar_noticias();
           })
           .catch(_ => {
           toastr.error("Debe iniciar sesión antes de continuar",
                       "Error",
                       {"iconClass": 'customer-danger'});
                       this.$router.push({path: '../../pages/login/'})
           });
         }
         else {
           toastr.error(error.response.data.details,
                       error.response.data.message,
                       {"iconClass": 'customer-danger'});
         }  
      })
    },
    
    obtener_sub_section_data(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec)
           .then(response => {
              
              this.nom_sub_sec_es = response.data.nom_sub_sec_es
              this.nom_sub_sec_en = response.data.nom_sub_sec_en
              this.internal_name_es = response.data.internal_name_es
              this.internal_name_en  = response.data.internal_name_en  
              this.desc_sub_section_es = response.data.desc_sub_section_es  
              this.desc_sub_section_en = response.data.desc_sub_section_en  
              this.section = response.data.section  
              this.url_1st_image = response.data.url_1st_image  
              this.url_2nd_image = response.data.url_2nd_image  
              this.url_3rd_image = response.data.url_3rd_image  
              this.url_4th_image = response.data.url_4th_image  
              this.url_5th_image = response.data.url_5th_image  
              this.type_1st_image = response.data.type_1st_image  
              this.type_2nd_image = response.data.type_2nd_image  
              this.type_3rd_image = response.data.type_3rd_image  
              this.type_4th_image = response.data.type_4th_image  
              this.type_5th_image = response.data.type_5th_image  
              this.text1_es = response.data.text1_es  
              this.text1_en = response.data.text1_en 
              this.text2_es = response.data.text2_es  
              this.text2_en = response.data.text2_en  
              this.text3_es = response.data.text3_es  
              this.text3_en = response.data.text3_en  
              this.orientation = response.data.orientation  
              this.url_es = response.data.url_es  
              this.url_en = response.data.url_en  
              this.order_sub_section = response.data.order_sub_section  
              this.id_position_menu = response.data.id_position_menu  
              this.url_video = response.data.url_video 
              this.type = response.data.type 

              //SEO
              this.page_title = this.nom_sub_sec_es;
              this.page_description = this.desc_sub_section_es;
              this.page_keywords = response.data.keywords;
              
          })
           .catch(error => {
            console.log("error");
      })
    },

    obtener_items_paginado(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/news')
           .then(response => {
             this.crit = 4
             this.item_list = response.data.news;
             this.pages = response.data.visible_pages
             this.final_page = response.data.final_page
             this.current_page = 1
             this.main_item = this.item_list.shift()
           })
           .catch(error => {
             console.log(error)
             this.mensaje_prev="Lo sentimos, no hay noticias para mostrar.";
           })
    },

    listadoPagina(page){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/news?cReg='+this.crit+'&&nPag='+page)
           .then(response => {
             var arreglo = response.data.news
             if(arreglo.length==0){
              this.listadoPagina(page - 1)
             }

             this.item_list = arreglo
             this.pages = response.data.visible_pages
             this.final_page = response.data.final_page
             this.current_page = page
             //this.mensaje_error = ""
             //this.mensaje = ""
           })
           .catch(error => {
             console.log(error.response.data.details);
              toastr.error(error.response.data.details,
                       error.response.data.message,
                       {"iconClass": 'customer-danger'});
                       this.mensaje_prev="Lo sentimos, no hay noticias para mostrar." ;
           })
    },

    scroll_inicio(){
      window.scrollTo(0,0);
    },

    openSignedDetail(item){
        //this.title = "Detalle xd";
        this.detail_open = true;
        this.detail_item = item;
        this.scroll_inicio();
        this.url_actual = "comunidad/"+item.id_news;
        //SEO
        this.page_title = item.title_news_es;
        this.page_description = item.desc_news_es;
        this.page_keywords = item.tags;
        window.history.pushState(item.id_news, "Detail", this.url_actual);              
    },

    closeSignedDetail(){
        this.detail_open = false;
        this.detail_item = new Object();
        this.scroll_inicio();
        this.url_actual = "/comunidad";
        //SEO
        this.page_title = this.nom_sub_sec_es;
        this.page_description = this.desc_sub_section_es;
        this.page_keywords = "";
        window.history.pushState("List", "Detail", this.url_actual);
    },

    finditem(id){
        this.closeSignedDetail()
        axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/news/'+id)
           .then(response => {
            console.log("Aca estamos: "+JSON.stringify(response.data))

             var noticia = response.data;
             this.openSignedDetail(noticia);
           })
           .catch(error => {
             console.log(error)
             console.log("Aca estamos 2")
          })
    },

    validacion_url() {
        if(this.id_news_url != '') {
              this.finditem(this.id_news_url);           
        }
        
    }

  },

  created() {
    this.scroll_inicio();
    this.obtener_sub_section_data();
    this.obtener_items_paginado();
    this.validacion_url();
  },

  watch: {
    '$route': function (route) {

      this.id_news_url= this.$route.params.idnews
      console.log("Holaaaaaaaaaa: "+this.id_news_url)
      this.validacion_url()

 
    }
  }
};
</script>